<div class="row">
  <div class="col-lg-12">
    <div class="container-fluid pl-0 info-list has-info-icon height-unset">
      <div *ngIf="!isFreemium">
        <app-line-chart [data]="lineChartData" [titleArray]="['Est. Ad Spend']" [valueTextPrefix]="'$'"
          [valueAxisPrecision]="2" [categoryField]="'month'" [valueFields]="['adSpend']"></app-line-chart>
      </div>
      <ng-container *ngIf="isFreemium">
        <div class="freemium-lock">
          <i class="fa fa-lock"></i>
        </div>
      </ng-container>
    </div>
  </div>
</div>